webpackJsonp([34],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	__webpack_require__(1);
	
	var _reactDom = __webpack_require__(192);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _configureStore = __webpack_require__(359);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	var _reducers = __webpack_require__(639);
	
	var _createRootRouter = __webpack_require__(816);
	
	var _createRootRouter2 = _interopRequireDefault(_createRootRouter);
	
	__webpack_require__(2260);
	
	__webpack_require__(1355);
	
	__webpack_require__(2032);
	
	__webpack_require__(2267);
	
	__webpack_require__(2269);
	
	var _screensTubeRouter = __webpack_require__(2287);
	
	var _screensTubeRouter2 = _interopRequireDefault(_screensTubeRouter);
	
	var _screensTubeReducers = __webpack_require__(742);
	
	var _screensTubeReducers2 = _interopRequireDefault(_screensTubeReducers);
	
	var _configs = __webpack_require__(487);
	
	var _utils = __webpack_require__(390);
	
	if (!window.Intl) {
	  __webpack_require__(2271);
	}
	if (!window.location.origin) {
	  (0, _utils.locationOrigin)();
	}
	
	var reducer = (0, _reducers.createRootReducer)('tube', _screensTubeReducers2['default']);
	var store = (0, _configureStore2['default'])(reducer, 'Tube', _configs.url.NEWTUBE_API_SERVER);
	var rootRouter = (0, _createRootRouter2['default'])(store, _screensTubeRouter2['default']);
	
	_reactDom2['default'].render(rootRouter, document.getElementById('root'));

/***/ },

/***/ 2287:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	var _screensDepartmentNewsRouter = __webpack_require__(2288);
	
	var _screensDepartmentNewsRouter2 = _interopRequireDefault(_screensDepartmentNewsRouter);
	
	var _screensCompanyNewsRouter = __webpack_require__(2407);
	
	var _screensCompanyNewsRouter2 = _interopRequireDefault(_screensCompanyNewsRouter);
	
	var _screensCompanyRulesRouter = __webpack_require__(2413);
	
	var _screensCompanyRulesRouter2 = _interopRequireDefault(_screensCompanyRulesRouter);
	
	var _screensInternalLinksRouter = __webpack_require__(2446);
	
	var _screensInternalLinksRouter2 = _interopRequireDefault(_screensInternalLinksRouter);
	
	var _screensLinksSettingRouter = __webpack_require__(2450);
	
	var _screensLinksSettingRouter2 = _interopRequireDefault(_screensLinksSettingRouter);
	
	var _screensStickyNotesRouter = __webpack_require__(2454);
	
	var _screensStickyNotesRouter2 = _interopRequireDefault(_screensStickyNotesRouter);
	
	var _screensCompanyAdminRouter = __webpack_require__(2490);
	
	var _screensCompanyAdminRouter2 = _interopRequireDefault(_screensCompanyAdminRouter);
	
	var _screensAssignmentTaskRouter = __webpack_require__(2503);
	
	var _screensAssignmentTaskRouter2 = _interopRequireDefault(_screensAssignmentTaskRouter);
	
	var _screensOrdersRouter = __webpack_require__(2526);
	
	var _screensOrdersRouter2 = _interopRequireDefault(_screensOrdersRouter);
	
	var _screensAccountSettingRouter = __webpack_require__(2590);
	
	var _screensAccountSettingRouter2 = _interopRequireDefault(_screensAccountSettingRouter);
	
	var _screensPeopleSearchRouter = __webpack_require__(2601);
	
	var _screensPeopleSearchRouter2 = _interopRequireDefault(_screensPeopleSearchRouter);
	
	var _screensCompanySpaceRouter = __webpack_require__(2632);
	
	var _screensCompanySpaceRouter2 = _interopRequireDefault(_screensCompanySpaceRouter);
	
	var _screensPrivacyRouter = __webpack_require__(2691);
	
	var _screensPrivacyRouter2 = _interopRequireDefault(_screensPrivacyRouter);
	
	var _screensGoogleOAuthPageRouter = __webpack_require__(2695);
	
	var _screensGoogleOAuthPageRouter2 = _interopRequireDefault(_screensGoogleOAuthPageRouter);
	
	var _containersAppComponentsEnsureLoggedIn = __webpack_require__(1992);
	
	var _containersAppComponentsEnsureLoggedIn2 = _interopRequireDefault(_containersAppComponentsEnsureLoggedIn);
	
	var _containersAppComponentsLayout = __webpack_require__(1997);
	
	var _containersAppComponentsLayout2 = _interopRequireDefault(_containersAppComponentsLayout);
	
	var _screensLoginPassRouter = __webpack_require__(2699);
	
	var _screensLoginPassRouter2 = _interopRequireDefault(_screensLoginPassRouter);
	
	var _screensVerificationRouter = __webpack_require__(2701);
	
	var _screensVerificationRouter2 = _interopRequireDefault(_screensVerificationRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  null,
	  _screensLoginPassRouter2['default'],
	  _react2['default'].createElement(
	    _reactRouter.Route,
	    { component: _containersAppComponentsLayout2['default'] },
	    _screensGoogleOAuthPageRouter2['default'],
	    _screensPrivacyRouter2['default'],
	    _screensVerificationRouter2['default'],
	    _react2['default'].createElement(
	      _reactRouter.Route,
	      { component: _containersAppComponentsEnsureLoggedIn2['default'] },
	      _react2['default'].createElement(
	        _reactRouter.Route,
	        { path: 'tube',
	          getComponent: function (location, cb) {
	            __webpack_require__.e/* nsure */(71, function (require) {
	              cb(null, __webpack_require__(2714));
	            });
	          }
	        },
	        _react2['default'].createElement(_reactRouter.IndexRoute, {
	          getComponent: function (location, cb) {
	            __webpack_require__.e/* nsure */(72, function (require) {
	              cb(null, __webpack_require__(2723));
	            });
	          }
	        }),
	        _screensDepartmentNewsRouter2['default'],
	        _screensCompanyNewsRouter2['default'],
	        _screensCompanyRulesRouter2['default'],
	        _screensInternalLinksRouter2['default'],
	        _screensLinksSettingRouter2['default'],
	        _screensStickyNotesRouter2['default'],
	        _screensAssignmentTaskRouter2['default'],
	        _screensCompanyAdminRouter2['default'],
	        _screensOrdersRouter2['default'],
	        _screensAccountSettingRouter2['default'],
	        _screensPeopleSearchRouter2['default'],
	        _screensCompanySpaceRouter2['default']
	      )
	    ),
	    _react2['default'].createElement(_reactRouter.Redirect, { from: '*', to: '/tube' })
	  )
	);
	module.exports = exports['default'];

/***/ },

/***/ 2288:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	var _screensAdminRouter = __webpack_require__(2289);
	
	var _screensAdminRouter2 = _interopRequireDefault(_screensAdminRouter);
	
	var _screensUserRouter = __webpack_require__(2398);
	
	var _screensUserRouter2 = _interopRequireDefault(_screensUserRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  {
	    getComponent: function (location, cb) {
	      __webpack_require__.e/* nsure */(37, function (require) {
	        cb(null, __webpack_require__(2406));
	      });
	    }
	  },
	  _screensAdminRouter2['default'],
	  _screensUserRouter2['default']
	);
	module.exports = exports['default'];

/***/ },

/***/ 2289:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'departmentnews/management',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(35, function (require) {
	      cb(null, __webpack_require__(2290));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2398:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'departmentnews',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(36, function (require) {
	      cb(null, __webpack_require__(2399));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2407:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	var _screensAdminRouter = __webpack_require__(2408);
	
	var _screensAdminRouter2 = _interopRequireDefault(_screensAdminRouter);
	
	var _screensUserRouter = __webpack_require__(2410);
	
	var _screensUserRouter2 = _interopRequireDefault(_screensUserRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  { path: 'companynews',
	    getComponent: function (location, cb) {
	      __webpack_require__.e/* nsure */(40, function (require) {
	        cb(null, __webpack_require__(2412));
	      });
	    }
	  },
	  _screensAdminRouter2['default'],
	  _screensUserRouter2['default']
	);
	module.exports = exports['default'];

/***/ },

/***/ 2408:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'management/:categoryId',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(38, function (require) {
	      cb(null, __webpack_require__(2409));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2410:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: ':categoryId',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(39, function (require) {
	      cb(null, __webpack_require__(2411));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2413:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	var _screensAdminRouter = __webpack_require__(2414);
	
	var _screensAdminRouter2 = _interopRequireDefault(_screensAdminRouter);
	
	var _screensUserRouter = __webpack_require__(2439);
	
	var _screensUserRouter2 = _interopRequireDefault(_screensUserRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  {
	    getComponent: function (location, cb) {
	      __webpack_require__.e/* nsure */(43, function (require) {
	        cb(null, __webpack_require__(2445));
	      });
	    }
	  },
	  _screensAdminRouter2['default'],
	  _screensUserRouter2['default']
	);
	module.exports = exports['default'];

/***/ },

/***/ 2414:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'companyrules/management',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(41, function (require) {
	      cb(null, __webpack_require__(2415));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2439:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'companyrules',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(42, function (require) {
	      cb(null, __webpack_require__(2440));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2446:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'internallinks',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(44, function (require) {
	      cb(null, __webpack_require__(2447));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2450:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'links/setting',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(45, function (require) {
	      cb(null, __webpack_require__(2451));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2454:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	var _screensReceivedRouter = __webpack_require__(2455);
	
	var _screensReceivedRouter2 = _interopRequireDefault(_screensReceivedRouter);
	
	var _screensSendedRouter = __webpack_require__(2476);
	
	var _screensSendedRouter2 = _interopRequireDefault(_screensSendedRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  {
	    path: 'stickynotes',
	    getComponent: function (location, cb) {
	      __webpack_require__.e/* nsure */(48, function (require) {
	        cb(null, __webpack_require__(2484));
	      });
	    }
	  },
	  _screensReceivedRouter2['default'],
	  _screensSendedRouter2['default']
	);
	module.exports = exports['default'];

/***/ },

/***/ 2455:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'received',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(46, function (require) {
	      cb(null, __webpack_require__(2456));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2476:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'sended',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(47, function (require) {
	      cb(null, __webpack_require__(2477));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2490:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  { path: 'admin',
	    getComponent: function (location, cb) {
	      __webpack_require__.e/* nsure */(49, function (require) {
	        cb(null, __webpack_require__(2491));
	      });
	    }
	  },
	  _react2['default'].createElement(_reactRouter.Route, {
	    path: 'orgimport',
	    getComponent: function (location, cb) {
	      __webpack_require__.e/* nsure */(50, function (require) {
	        cb(null, __webpack_require__(2499));
	      });
	    }
	  })
	);
	module.exports = exports['default'];

/***/ },

/***/ 2503:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	var _screensReceivedRouter = __webpack_require__(2504);
	
	var _screensReceivedRouter2 = _interopRequireDefault(_screensReceivedRouter);
	
	var _screensSendedRouter = __webpack_require__(2515);
	
	var _screensSendedRouter2 = _interopRequireDefault(_screensSendedRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  {
	    path: 'assignmenttask',
	    getComponent: function (Location, cb) {
	      __webpack_require__.e/* nsure */(53, function (require) {
	        cb(null, __webpack_require__(2523));
	      });
	    }
	  },
	  _screensReceivedRouter2['default'],
	  _screensSendedRouter2['default']
	);
	module.exports = exports['default'];

/***/ },

/***/ 2504:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'received(/:assignmentId)',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(51, function (require) {
	      cb(null, __webpack_require__(2505));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2515:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'sended(/:assignmentId)',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(52, function (require) {
	      cb(null, __webpack_require__(2516));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2526:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	var _screensActiveRouter = __webpack_require__(2527);
	
	var _screensActiveRouter2 = _interopRequireDefault(_screensActiveRouter);
	
	var _screensEndRouter = __webpack_require__(2564);
	
	var _screensEndRouter2 = _interopRequireDefault(_screensEndRouter);
	
	var _screensStoreRouter = __webpack_require__(2569);
	
	var _screensStoreRouter2 = _interopRequireDefault(_screensStoreRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  {
	    path: 'orders',
	    getComponent: function (Location, cb) {
	      __webpack_require__.e/* nsure */(57, function (require) {
	        cb(null, __webpack_require__(2580));
	      });
	    }
	  },
	  _screensActiveRouter2['default'],
	  _screensEndRouter2['default'],
	  _screensStoreRouter2['default']
	);
	module.exports = exports['default'];

/***/ },

/***/ 2527:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'active(/:orderingId)',
	  getComponent: function (Location, cb) {
	    __webpack_require__.e/* nsure */(54, function (require) {
	      cb(null, __webpack_require__(2528));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2564:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'end',
	  getComponent: function (Location, cb) {
	    __webpack_require__.e/* nsure */(55, function (require) {
	      cb(null, __webpack_require__(2565));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2569:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'store',
	  getComponent: function (Location, cb) {
	    __webpack_require__.e/* nsure */(56, function (require) {
	      cb(null, __webpack_require__(2570));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2590:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'AccountSetting',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(58, function (require) {
	      cb(null, __webpack_require__(2591));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2601:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	var _screensListScreensEmployeeRouter = __webpack_require__(2602);
	
	var _screensListScreensEmployeeRouter2 = _interopRequireDefault(_screensListScreensEmployeeRouter);
	
	var _screensListScreensDepartmentRouter = __webpack_require__(2618);
	
	var _screensListScreensDepartmentRouter2 = _interopRequireDefault(_screensListScreensDepartmentRouter);
	
	var _screensListScreensUnderDepartmentRouter = __webpack_require__(2622);
	
	var _screensListScreensUnderDepartmentRouter2 = _interopRequireDefault(_screensListScreensUnderDepartmentRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  {
	    path: 'peoplesearch'
	  },
	  _react2['default'].createElement(_reactRouter.IndexRoute, {
	    getComponent: function (Location, callback) {
	      __webpack_require__.e/* nsure */(62, function (require) {
	        callback(null, __webpack_require__(2626));
	      });
	    }
	  }),
	  _screensListScreensUnderDepartmentRouter2['default'],
	  _screensListScreensDepartmentRouter2['default'],
	  _screensListScreensEmployeeRouter2['default']
	);
	module.exports = exports['default'];

/***/ },

/***/ 2602:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: '(:id)',
	  i18nCrumbKey: 'SH_EmployeeData',
	  i18nCrumbDefaultMessage: '員工資料',
	  getComponent: function (Location, callback) {
	    __webpack_require__.e/* nsure */(59, function (require) {
	      callback(null, __webpack_require__(2603));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2618:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'DepartmentId/(:departmentId)',
	  getComponent: function (Location, callback) {
	    __webpack_require__.e/* nsure */(60, function (require) {
	      callback(null, __webpack_require__(2619));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2622:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, {
	  path: 'employee/(:departmentId)',
	  getComponent: function (Location, callback) {
	    __webpack_require__.e/* nsure */(61, function (require) {
	      callback(null, __webpack_require__(2623));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2632:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	var _screensPermissionRouter = __webpack_require__(2633);
	
	var _screensPermissionRouter2 = _interopRequireDefault(_screensPermissionRouter);
	
	var _screensPermissionSearchRouter = __webpack_require__(2641);
	
	var _screensPermissionSearchRouter2 = _interopRequireDefault(_screensPermissionSearchRouter);
	
	var _screensSiteSettingRouter = __webpack_require__(2645);
	
	var _screensSiteSettingRouter2 = _interopRequireDefault(_screensSiteSettingRouter);
	
	exports['default'] = _react2['default'].createElement(
	  _reactRouter.Route,
	  { path: 'companyspace',
	    getComponent: function (location, cb) {
	      __webpack_require__.e/* nsure */(66, function (require) {
	        cb(null, __webpack_require__(2688));
	      });
	    }
	  },
	  _screensPermissionRouter2['default'],
	  _screensPermissionSearchRouter2['default'],
	  _screensSiteSettingRouter2['default']
	);
	module.exports = exports['default'];

/***/ },

/***/ 2633:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, { path: 'permission',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(63, function (require) {
	      cb(null, __webpack_require__(2634));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2641:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, { path: 'permissionsearch',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(64, function (require) {
	      cb(null, __webpack_require__(2642));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2645:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, { path: 'sitesetting',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(65, function (require) {
	      cb(null, __webpack_require__(2646));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2691:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, { path: 'privacy',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(67, function (require) {
	      cb(null, __webpack_require__(2692));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2695:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, { path: 'google-auth-page',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(68, function (require) {
	      cb(null, __webpack_require__(2696));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2699:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, { path: '/LoginPass',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(69, function (require) {
	      cb(null, __webpack_require__(2700));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ },

/***/ 2701:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(641);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(881);
	
	exports['default'] = _react2['default'].createElement(_reactRouter.Route, { path: 'verification',
	  getComponent: function (location, cb) {
	    __webpack_require__.e/* nsure */(70, function (require) {
	      cb(null, __webpack_require__(2702));
	    });
	  }
	});
	module.exports = exports['default'];

/***/ }

});


/** WEBPACK FOOTER **
 ** tube.js
 **/